import { EmptystateDataFlowColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const ScanRunsEmptyState = () => (
  <EmptyState
    title="No runs yet"
    caption="Trigger this scan and every run shows up here with its status and what it discovered."
    icon={EmptystateDataFlowColored}
    fullHeight
    announce
  />
);

export default ScanRunsEmptyState;
